import React, { forwardRef } from "react";
import { Button, useViewport } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import useSubmit from "./useSubmit.js";
import styles from "./Submit.module.css";
const SubmitWithRef = forwardRef(function Submit(props, ref) {
    const { className, onClick, ...rest } = props;
    const { isLarge } = useViewport();
    const { i18n, trackV2, doSearch, isResponsiveFixes, isMultiStop, allowEmptyDestination, isDestinationEmpty, isMobile } = useSubmit();
    return (React.createElement(Button, { ...rest, onClick: (e) => {
            trackV2("click_submit_search");
            doSearch();
            setTimeout(() => onClick?.(e), 0);
        }, text: !isMultiStop && isDestinationEmpty && allowEmptyDestination
            ? i18n.trans(t("flights_cat_sb_explore_action"))
            : i18n.trans(t("flights_search_button")), className: `${styles.cta} ${className} ${styles.font}`, attributes: { "data-ui-name": "button_search_submit" }, ref: ref, size: isMobile || (!isLarge && !isMultiStop && isResponsiveFixes) ? "large" : undefined }));
});
export default SubmitWithRef;
